import { useBuild } from "~/components/build/Show/lib/BuildContext";
import EmojiAvatar from "~/components/shared/EmojiAvatar";
import Emojify from "~/components/shared/Emojify";
import { PipelineSettings } from "~/components/build/Header/PipelineSettings";
import Badge from "~/components/shared/Badge";
import { twMerge } from "tailwind-merge";

export const PipelineInfo = () => {
  const { build } = useBuild();
  const { project } = build;

  return (
    <div
      className={twMerge(
        "flex min-w-0 max-w-xs flex-initial [flex-basis:100%] sm:[flex-basis:auto]",
        !Features.ConsolidatedPipelineSettings && "-mr-2",
      )}
    >
      <a
        className="group flex max-w-full items-center gap-2 truncate text-inherit no-underline hover:text-inherit"
        href={project.url}
      >
        <EmojiAvatar
          emoji={project.emoji}
          color={project.color}
          className="!h-6 !w-6 !text-sm [&>svg]:h-4 [&>svg]:w-4"
        />
        <span
          className="max-w-full truncate text-base/5 font-medium group-hover:underline"
          data-testid="projectUrl"
        >
          <Emojify text={project.name} />
        </span>
      </a>

      {project.public && (
        <Badge outline={true} className="text-charcoal-600 ml-1">
          Public
        </Badge>
      )}

      {!Features.ConsolidatedPipelineSettings && project.permissions.edit?.allowed && (
        <PipelineSettings />
      )}
    </div>
  );
};
